import { useTranslation } from 'react-i18next'
import { Radio, RadioChangeEvent, Space, Typography } from 'antd'
import { BuildingFile } from 'types/building'

import Button from 'components/atoms/Button'
import Modal from 'components/atoms/Modal'
import Title from 'components/atoms/Title'

type Props = {
  open: boolean
  duplicateFiles: { newFile: File; oldFile: BuildingFile }[]
  selectedOption: number
  setSelectedOption: (option: number) => void
  onCancel: () => void
  onConfirm: () => void
  afterClose?: () => void
}

export default function DuplicateFileModal({
  open,
  duplicateFiles,
  selectedOption,
  setSelectedOption,
  onCancel,
  onConfirm,
  afterClose = () => {}
}: Props) {
  const { t } = useTranslation()

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      afterClose={afterClose || onCancel}
      width={600}
      centered
      className="duplicate-options-modal"
      isEnterable
      onEnter={onConfirm}
    >
      <Title
        title={t('building.duplicateFileModal.title')}
        bottomMargin="mb-8"
      />
      <div className="flex flex-col gap-6">
        <Typography className="text-[#1a1a1a] text-[16px] leading-[24px]">
          {duplicateFiles.length > 1
            ? t('building.duplicateFileModal.descriptionMultiple')
            : t('building.duplicateFileModal.description', {
                fileName: duplicateFiles[0]?.newFile.name
              })}
        </Typography>

        <Radio.Group
          onChange={(e: RadioChangeEvent) => setSelectedOption(e.target.value)}
          value={selectedOption}
          className="w-full"
        >
          <Space direction="vertical" className="w-full gap-4">
            <Radio
              value={1}
              className="text-[16px] flex items-center custom-radio-large"
            >
              <span className="text-[16px]">
                {t('building.duplicateFileModal.replace')}
              </span>
            </Radio>
            <Radio
              value={2}
              className="text-[16px] flex items-center custom-radio-large"
            >
              <span className="text-[16px]">
                {t('building.duplicateFileModal.keepBoth')}
              </span>
            </Radio>
          </Space>
        </Radio.Group>

        {selectedOption === 1 && (
          <Typography className="text-red-500 text-[16px] leading-[24px] italic">
            {t('building.duplicateFileModal.overwriteNote')}
          </Typography>
        )}

        <div className="flex justify-center gap-10 mt-6">
          <Button sizing="w-36 h-12" onClick={onCancel}>
            {t('building.buttonCancel')}
          </Button>
          <Button type="primary" sizing="w-36 h-12" onClick={onConfirm}>
            {t('building.duplicateFileModal.upload')}
          </Button>
        </div>
      </div>
    </Modal>
  )
}

DuplicateFileModal.defaultProps = {
  afterClose: undefined
}
